import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpenText, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import Invitations from "./Invitations";
import FailedSchedules from "./FailedSchedules";

const TABS = [
  { key: "invitations", label: "Invitations", icon: faEnvelopeOpenText },
  { key: "failed",      label: "Failed Schedules", icon: faTriangleExclamation },
];

const InfoView = () => {
  const location = useLocation();
  const initialTab = location.state?.tab ?? "invitations";
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="page-section-header" style={{ marginBottom: 0 }}>
          <span className="page-section-header-icon" style={{ background: "rgba(3,142,220,0.12)" }}>
            <i className="uil uil-info-circle" style={{ color: "#038edc", fontSize: 16 }} />
          </span>
          Info
        </h4>
      </div>

      {/* Tab bar */}
      <div style={{ display: "flex", gap: 4, borderBottom: "2px solid #eaecf0", marginBottom: 24 }}>
        {TABS.map(({ key, label, icon }) => {
          const active = activeTab === key;
          const isError = key === "failed";
          const color = active ? (isError ? "#f34e4e" : "#038edc") : "#9299a8";
          return (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              style={{
                display: "flex", alignItems: "center", gap: 7,
                padding: "10px 18px", border: "none", background: "transparent",
                cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 500,
                color,
                borderBottom: active ? `2px solid ${color}` : "2px solid transparent",
                marginBottom: -2,
                transition: "color 0.15s",
              }}
            >
              <FontAwesomeIcon icon={icon} style={{ fontSize: 13 }} />
              {label}
            </button>
          );
        })}
      </div>

      {activeTab === "invitations" && <Invitations />}
      {activeTab === "failed" && <FailedSchedules />}
    </>
  );
};

export default InfoView;
